import React from "react";
import { Box, Container, Link, Typography } from "@mui/material";

export default function Footer() {
    return (
        <Box
            sx={{
                py: 3,
                px: 2,
                mt: "auto",
                backgroundColor: (theme) =>
                    theme.palette.mode === "light"
                        ? theme.palette.grey[200]
                        : theme.palette.grey[800],
            }}
        >
            <Container maxWidth="sm">
                <Typography variant="body1" align="center">
                    Made by{" "}
                    <Link href="https://github.com/adelansari" color="inherit">
                        <b>Adel Ansari</b>
                    </Link>{" "}
                    for FS13 Integrify Academy
                </Typography>
            </Container>
        </Box>
    );
};
